import { createElement, lazy } from 'react'

import { routes } from '../routes'
import { registerRoute } from '../utils/routeRegistry'

const ConfirmDelivery = lazy(() => import(/* webpackChunkName: 'confirm-delivery' */ './confirmDelivery'))

const initRoute = () => {
    registerRoute({ path: routes.CONFIRM_DELIVERY, element: createElement(ConfirmDelivery) })
}

export default initRoute
